function getCoupon(couponId, restaurant) {
    let results;

    restaurant.coupons.forEach(coupon => {
        if (couponId == coupon.code) {
            results = {
                accepted: true,
                code: coupon.code,
                discount: coupon.percentage,
                name: coupon.description,
                restaurantAccepted: restaurant.id,
            }
        }
    });

    if (results) {
        return results;
    }

    return {
        accepted: false,
        discount: "",
    }
}

export default {
    getCoupon,
}
